import ProductTransformer from './ProductTransformer';

export default class ProductChangeConfirmationTransformer extends ProductTransformer {
  static addFootnote(fn, product) {
    if (fn.name === 'footNoteChangeConfirmation') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    ['productChangeConfirmation', 'productChangeConfirmationBeforeButtons', 'productChangeConfirmationAfterButtons'].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
  }
}
